<template>
  <div :class="divWidthChange" class="conteudoWidth fccEmulados">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsGrupo"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actionsGrupo"
          :items="listaEmuladores"
        >
        </fccTable>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import axios from 'axios'
import './../assets/fccUsuarios.scss'

export default {
  data() {
    return {
      statusGrupo: [
        {
          funcaoButton: 'changeGrupo',
          tooltip: 'Alterar Status',
          campoStatus: 'perativo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      fieldsGrupo: [
        { key: 'usuid', label: 'ID', sortable: true, active: true },
        {
          key: 'usucompnome',
          label: 'Nome',
          sortable: true,
          active: true,
          type: 'sub',
          sub: { sub1: 'usuariocomplemento', sub2: 'usucompnome' }
        },
        {
          key: 'usucompsgsetor',
          label: 'Setor',
          sortable: true,
          active: true,
          type: 'sub',
          sub: { sub1: 'usuariocomplemento', sub2: 'usucompsgsetor' }
        },
        { key: 'totalemulados', label: 'Total emulados', sortable: true, active: true },
        {
          key: 'usuemuexterno',
          label: 'Apenas Externo',
          type: 'toggle',
          funcaoButton: this.editandoEmulador,
          tdClass: 'no-print',
          thClass: 'no-print',
          objpermCodigo: store.state.permissaoMenu.editar
        },

        { key: 'actions', label: '', active: true }
      ],
      actionsGrupo: [
        {
          button: true,
          funcaoButton: 'editEmulador',
          icon: 'eye',
          tooltip: 'Visualizar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deletandoEmulador',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      baseUrlSeguranca: '',
      fechaPesquisa: '',
      sortBy: 'ordem',
      titlePage: 'Emuladores',
      titleModal: '',
      formActive: 0,
      listaEmuladores: [],
      emulador: {},
      emulados: [],
      titlePDF: 'Emuladores',
      itemPorPage: '100'
    }
  },
  methods: {
    listandoEmuladores() {
      this.listEmuladores().then((response) => {
        this.listaEmuladores = response
      })
    },
    editEmulador: function (_, item) {
      this.$router.push({ path: '/seguranca/emuladores/' + item.usuid + '/false' })
    },
    editandoEmulador: function (_, item) {
      const emula = {
        usuEmuID: item.usuemuid,
        usuID: item.usuid,
        usuEmuExterno: item.usuemuexterno
      }
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .put(
          store.state.baseUrlSegurancaSGP + 'Emulados/alteraremula',
          emula,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.listandoEmuladores()
        })
        .finally(this.carregaTexto)
    },
    deletandoEmulador: function (_, item) {
      this.callConfirm(this.mensagemExcluir, item.usuid).then((result) => {
        if (result.value) {
          this.deleteEmulador(item.usuemuid).then(() => {
            this.callToast(this.mensagensUpdate.excluido, 'success')
            this.listandoEmuladores()
          })
        }
      })
    },
    addField: function () {
      this.titleModal = 'Adicionar Emulador'
      this.emulador = {}
      this.emulador.usuEmuID = 0
      this.$root.$emit('bv::show::modal', 'editEmulador')
    }
  },
  mounted: function () {
    this.baseUrlSeguranca = this.$fccStore.state.baseUrlSeguranca
    this.listandoEmuladores()
  }
}
</script>
